import { render, staticRenderFns } from "./statistics.vue?vue&type=template&id=7f6b696d&scoped=true"
import script from "./statistics.vue?vue&type=script&lang=js"
export * from "./statistics.vue?vue&type=script&lang=js"
import style0 from "./statistics.vue?vue&type=style&index=0&id=7f6b696d&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f6b696d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_manage_sbGx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7f6b696d')) {
      api.createRecord('7f6b696d', component.options)
    } else {
      api.reload('7f6b696d', component.options)
    }
    module.hot.accept("./statistics.vue?vue&type=template&id=7f6b696d&scoped=true", function () {
      api.rerender('7f6b696d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/course/statistics.vue"
export default component.exports